module.exports = __webpack_public_path__ + "assets/icons/icon_signal0.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/svg/icon_signal0.svg
// module id = QDzy
// module chunks = 1